export default __webpack_public_path__ + "static/media/Mystic's Wrist-straps of the Eldritch.00ee38c7.jpg";